import { Carousel } from "primereact/carousel";
import {
  LazyImage,
  LazySliderImage,
  LazySliderVideo,
  LazyVideo,
} from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { feedLikeList, feedLikePost } from "../Services/DashboardServices";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Dialog } from "primereact/dialog";
import { TostMsg } from "../../../../App";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import { useSelector } from "react-redux";
const defaultImage = "/images/placeholder_profile.png";
const feedDefaultImage = "/images/no-data-found/feed_dummy.png";

export const FeedSliderCarousel = ({ templateData, itemIndex }) => {
  const [likeListData, setLikeListData] = useState([]);
  const [likeListFilterData, setLikeListFilterData] = useState([]);
  const [visibleLike, setVisibleLike] = useState(false);
  const [feedlst, setFeedlst] = useState(templateData);
  const ApplyLeaveRequestData = useSelector(
    (state) => state.leave.leaveRequestData
  );
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);
  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  useEffect(() => {
    setFeedlst(templateData);
  }, [ApplyLeaveRequestData]);

  const handleFeedImageError = useCallback((event) => {
    event.target.src = feedDefaultImage;
  }, []);

  const index = itemIndex;
  let likeList = [];

  const [posterSrc, setPosterSrc] = useState("");

  useEffect(() => {
    const video = document.getElementById("videoElement");
    if (video) {
      video.addEventListener("loadeddata", () => {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const poster = canvas.toDataURL("image/jpeg");
        setPosterSrc(poster);
      });
    }
  }, []);

  useEffect(() => {}, [likeListData]);

  const FeedCarouselTemplate = useCallback(
    (media, index) => {
      const isVideo =
        media?.MediaPath?.endsWith(".mp4") ||
        media?.MediaPath?.toLowerCase()?.endsWith(".mov");
      const mediaSrc = media?.MediaPath || feedDefaultImage;
      return isVideo ? (
        <LazyVideo
          id="videoElement"
          src={mediaSrc}
          poster={posterSrc}
          playsInline
          muted
          controls
        />
      ) : (
        <img
          src={mediaSrc}
          onError={handleFeedImageError}
          alt="Description of the image"
        />
      );
    },
    [feedlst]
  );

  async function FeedLikePost(lst, type, action, i) {
    if (lst.MyReaction == type) {
      const reactionsArray = lst?.Reactions?.toString()?.split(",") || [];
      const updatedFeedComment = {
        ...feedlst,
        MyReaction: "",
        Reactions: reactionsArray?.filter((item) => item !== type),
        LikesCount: feedlst?.LikesCount - 1,
        IsLikedByMe: feedlst?.IsLikedByMe - 1,
      };
      setFeedlst(updatedFeedComment);
    } else {
      const reactionsArray = lst?.Reactions?.toString()?.split(",") || [];
      if (lst.MyReaction === "") {
        const updatedFeedComment = {
          ...feedlst,
          MyReaction: type,
          Reactions: [...reactionsArray, type],
          LikesCount: feedlst?.LikesCount + 1,
          IsLikedByMe: feedlst?.IsLikedByMe + 1,
        };
        setFeedlst(updatedFeedComment);
      } else {
        const index = reactionsArray?.indexOf(lst.MyReaction);
        if (index > -1) {
          reactionsArray[index] = type;
        }
        const updatedFeedComment = {
          ...feedlst,
          MyReaction: type,
          Reactions: reactionsArray,
          LikesCount: feedlst?.LikesCount,
          IsLikedByMe: feedlst?.IsLikedByMe,
        };
        setFeedlst(updatedFeedComment);
      }
    }

    let reactionTypeId;
    let isLike;
    let LastCommentById;
    if (lst.MyReaction == type) {
      isLike = false;
    } else {
      isLike = true;
    }
    const body = {
      FeedId: Number(lst.Id),
      CommentId: 0,
      ReactionById: userDetails?.EmpId,
      ReactionTypeId: reactionTypeId,
      Reaction: type,
      IsLike: isLike,
    };
    try {
      await feedLikePost(body);
    } catch (error) {
      toster.current.warn(ERROR_LIST.DashboardLike);
    }
  }


  const renderFeedText = (text) => {
    const mentionRegex = /@\w+/g;
    const hashtagRegex = /#\w+/g;
    const urlRegex =
      /((?:https?:\/\/)?(?:www\.)?(?:app\.orggenie(?:\.com)?\/[^\s]+)|https?:\/\/[^\s]+)/gi;
    const postMention = text?.PostMentions;
    let feedText = text?.FeedText || "";
    feedText = feedText.replace(/(https?:\/\/[^\s]+)(https?:\/\/)/g, "$1 $2");
    feedText = feedText.replace(
      /\b(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?:\1)+/gi,
      "$1"
    );
    let newText = feedText.replace(mentionRegex, (mention) => {
      const matchedMention = postMention?.find(
        (emp) => "@" + emp.MentionedName?.replace(/ /g, "") === mention
      );
      if (matchedMention) {
        return `<a style=${{ color: "#4EA8DE", textDecoration: "none" }} href="/Profile/${matchedMention.MentionedUserId}">${matchedMention.MentionedName}</a>`
      }
      return mention;
    });
    newText = newText.replace(hashtagRegex, (hashtag) => {
      return `<span style="color:#c4c6c7;text-decoration:none;" >${hashtag}</span>`;
    });
    const usedLinks = new Set();
    newText = newText.replace(urlRegex, (url) => {
      let link = url.trim();
      if (!/^https?:\/\//i.test(link)) link = "https://" + link;
      if (usedLinks.has(link)) return "";
      usedLinks.add(link);
      const internalGoPattern =
        /https?:\/\/app\.orggenie(?:\.com)?\/go\/(Article|Announcement|Award|Policy)(?:\/Detail)?\/([a-zA-Z0-9-]+)(?:\/\d+)?/i;
      const m = link.match(internalGoPattern);
      if (m) {
        const type = m[1];
        const id = m[2];
        const trailingMatch = link.match(/\/[a-zA-Z0-9-]+\/(\d+)$/);
        const extra =
          trailingMatch && link.includes(`/Detail/${id}/`)
            ? `/${trailingMatch[1]}`
            : "";
        const newLink = `https://app.orggenie.com/${type}/Detail/${id}${extra}`;
        return `<a href="${newLink}" target="_blank" rel="noopener noreferrer" style="color:#0d6efd;text-decoration:underline;">Click Here</a>`;
      }
      return `<a href="${link}" target="_blank" rel="noopener noreferrer" style="color:#0d6efd;text-decoration:underline;">${link}</a>`;
    });
    return { __html: newText };
  };

  const MyEmojiReaction = (reaction) => {
    var replaceSameEmoji = reaction?.toString();
    const replacedEmoji = Array.from(
      new Set(replaceSameEmoji?.split(","))
    )?.join(",");
    return (
      <div className="emojis-group">
        {replacedEmoji.includes("Love") ? (
          <LazyImage src="/images/main-body/post/emojis/1.gif" alt="" />
        ) : (
          ""
        )}
        {replacedEmoji.includes("Like") ? (
          <LazyImage src="/images/main-body/post/emojis/0.gif" alt="" />
        ) : (
          ""
        )}
        {replacedEmoji.includes("Laugh") ? (
          <LazyImage src="/images/main-body/post/emojis/2.gif" alt="" />
        ) : (
          ""
        )}
        {replacedEmoji.includes("Surprised") ? (
          <LazyImage src="/images/main-body/post/emojis/3.gif" alt="" />
        ) : (
          ""
        )}
        {replacedEmoji.includes("Sad") ? (
          <LazyImage src="/images/main-body/post/emojis/5.gif" alt="" />
        ) : (
          ""
        )}
      </div>
    );
  };

  function FeedLikeChange(likeData, type) {
    if (type == "All") {
      setLikeListData(likeData);
    } else if (type == "Like") {
      let likes = likeData?.filter((data) => data.Reaction == "Like");
      setLikeListData(likes);
    } else if (type == "Love") {
      let likes = likeData?.filter((data) => data.Reaction == "Love");
      setLikeListData(likes);
    } else if (type == "Laugh") {
      let likes = likeData?.filter((data) => data.Reaction == "Laugh");
      setLikeListData(likes);
    } else if (type == "Surprised") {
      let likes = likeData?.filter((data) => data.Reaction == "Surprised");
      setLikeListData(likes);
    } else if (type == "Sad") {
      let likes = likeData?.filter((data) => data.Reaction == "Sad");
      setLikeListData(likes);
    }
  }

  async function FeedLikeListData(Id) {
    const body = {
      LoggedInUserId: userDetails?.EmpId,
      FeedId: Id,
      FeedGUID: "",
      CommentId: 0,
      pageNumber: 1,
      pageSize: 1000000,
    };
    try {
      let LikeList = await feedLikeList(body);
      setLikeListData(LikeList?.Data);
      setLikeListFilterData(LikeList?.Data);
      setVisibleLike(true);
      FeedLikeChange(LikeList?.Data, "All");
    } catch (error) {
      toster.current.error(ERROR_LIST?.FeedLikePostOnFeedDetails);
    }
  }

  function LikeListDataUpdate() {
    setLikeListData([]);
  }

  const FeedSingleTemplate = useCallback((media) => {
    const isVideo =
      media?.PostMedia[0]?.MediaPath?.endsWith(".mp4") ||
      media?.PostMedia[0]?.MediaPath?.toLowerCase()?.endsWith(".mov");
    const mediaSrc = media?.PostMedia[0]?.MediaPath; //|| defaultImage;

    return isVideo ? (
      <LazySliderVideo
        id="videoElement"
        src={mediaSrc}
        playsInline
        muted
        controls
      />
    ) : (
      <LazySliderImage
        style={{ borderRadius: "0 !important" }}
        src={mediaSrc}
        onError={handleImageError}
        alt="Description of the image"
      />
    );
  }, []);

  return (
    <>
      <div className="post-text">
        <p style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={renderFeedText(feedlst)}></p>
        <p></p>
      </div>

      <div className={feedlst?.PostMedia?.length >= 1 ? "post-image" : ""}>
        {feedlst?.PostMedia?.length == 1 ? (
          FeedSingleTemplate(feedlst)
        ) : (
          <a
            className="imgs-videos"
            data-fancybox="post1"
            data-lightbox-type="comments"
            data-thumb="/images/main-body/1(1).jpg"
            data-demo-href="/images/main-body/1(1).jpg"
          >
            {feedlst?.PostMedia?.length > 1 && (
              <Carousel
                value={feedlst.PostMedia}
                numVisible={1}
                numScroll={1}
                className="custom-carousel"
                circular
                autoplayInterval={8000}
                itemTemplate={FeedCarouselTemplate}
              />
            )}
          </a>
          // FeedSingleTemplate(feedlst?.PostMedia)
        )}
        {/* post-footer   hide for the design issue */}
        <div key={index} className="post-footer mt-3">
          <p
            className="mb-0 like-list d-none"
            key={index}
            data-bs-toggle="modal"
            data-bs-target="#pending-request"
          ></p>
          <div className="totallikes">
            {feedlst?.MyReaction ? (
              <div className="emojis-group">
                {MyEmojiReaction(feedlst?.MyReaction)}

                <span className="like-overlay"></span>
                <div
                  className="upload-like"
                  style={{
                    left: "-16px",
                    bottom: "14px",
                    width: "fit-content",
                    height: "40px",
                  }}
                >
                  <ul className="emoji-ul" style={{ height: "40px" }}>
                    <li>
                      <img
                        src="/images/main-body/post/emojis/0.gif"
                        alt=""
                        onClick={() => FeedLikePost(feedlst, "Like")}
                      />
                    </li>
                    <li>
                      <img
                        src="/images/main-body/post/emojis/1.gif"
                        alt=""
                        onClick={() => FeedLikePost(feedlst, "Love")}
                      />
                    </li>
                    <li>
                      <img
                        src="/images/main-body/post/emojis/2.gif"
                        alt=""
                        onClick={() => FeedLikePost(feedlst, "Laugh")}
                      />
                    </li>
                    <li>
                      <img
                        src="/images/main-body/post/emojis/3.gif"
                        alt=""
                        onClick={() => FeedLikePost(feedlst, "Surprised")}
                      />
                    </li>
                    <li>
                      <img
                        src="/images/main-body/post/emojis/5.gif"
                        alt=""
                        onClick={() => FeedLikePost(feedlst, "Sad")}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            ) : (
              // MyEmojiReaction(feedlst?.MyReaction)
              // MyEmojiReaction(feedlst?.MyReaction)
              <a className="likes emojis-group">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-hand-thumbs-up"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2 2 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a10 10 0 0 0-.443.05 9.4 9.4 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a9 9 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.2 2.2 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.9.9 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" />
                </svg>
                <span className="like-overlay"></span>
                <div
                  className="upload-like"
                  style={{
                    left: "0rem",
                    bottom: "1.0rem",
                    width: "fit-content",
                  }}
                >
                  <ul className="emoji-ul">
                    <li>
                      <img
                        src="/images/main-body/post/emojis/0.gif"
                        alt=""
                        onClick={() => FeedLikePost(feedlst, "Like")}
                      />
                    </li>
                    <li>
                      <img
                        src="/images/main-body/post/emojis/1.gif"
                        alt=""
                        onClick={() => FeedLikePost(feedlst, "Love")}
                      />
                    </li>
                    <li>
                      <img
                        src="/images/main-body/post/emojis/2.gif"
                        alt=""
                        onClick={() => FeedLikePost(feedlst, "Laugh")}
                      />
                    </li>
                    <li>
                      <img
                        src="/images/main-body/post/emojis/3.gif"
                        alt=""
                        onClick={() => FeedLikePost(feedlst, "Surprised")}
                      />
                    </li>
                    <li>
                      <img
                        src="/images/main-body/post/emojis/5.gif"
                        alt=""
                        onClick={() => FeedLikePost(feedlst, "Sad")}
                      />
                    </li>
                  </ul>
                </div>
              </a>
            )}
            <>
              {feedlst?.IsLikedByMe === 0 && feedlst?.LikesCount === 0 && (
                <span> </span>
              )}
              {feedlst?.IsLikedByMe === 0 && feedlst?.LikesCount >= 1 && (
                <span onClick={() => FeedLikeListData(feedlst?.Id)}>
                  {feedlst.LikesCount}{" "}
                  {feedlst?.LikesCount >= 1 ? "Other" : "Others"} like this
                </span>
              )}
              &nbsp;{" "}
              {feedlst?.IsLikedByMe === 1 && feedlst?.LikesCount == 1 && (
                <span onClick={() => FeedLikeListData(feedlst?.Id)}>
                  You like this
                </span>
              )}
              {feedlst?.IsLikedByMe === 1 && feedlst?.LikesCount >= 2 && (
                <span onClick={() => FeedLikeListData(feedlst?.Id)}>
                  You and {feedlst?.LikesCount - 1}{" "}
                  {feedlst?.LikesCount == 2 ? "other" : "others"} like this
                </span>
              )}
            </>
          </div>
          <div className="comments-count">
            <Link to={`/Feed/Post/${feedlst?.GUID}`} className="atag">
              {" "}
              <span>
                {feedlst?.TotalComments == 1
                  ? ApplyLeaveRequestData + " Comment"
                  : ""}
                {feedlst?.TotalComments >= 2
                  ? ApplyLeaveRequestData + " Comments"
                  : ""}
              </span>
            </Link>
          </div>
        </div>
      </div>

      <Dialog
        visible={visibleLike}
        style={{ width: "20vw" }}
        onHide={() => {
          if (!visibleLike) return;
          setVisibleLike(false);
          LikeListDataUpdate();
        }}
      >
        <div className="total-likesmodal">
          <div className="modal-header p-0 px-2">
            <strong className="modal-title">
              <h5 className="modal-title">People who reacted</h5>
            </strong>
          </div>

          <div className="modal-body text-center">
            <div className="likeItemArrange">
              <div className="likediv">
                <span
                  type="button"
                  data-bs-dismiss="model"
                  onClick={() => FeedLikeChange(likeListFilterData, "All")}
                >
                  All
                </span>
              </div>

              {likeListFilterData?.filter((item) => item.Reaction === "Like")
                .length > 0 && (
                <div className="likediv">
                  <button className="" type="button">
                    <img
                      src="/images/main-body/post/emojis/0.gif"
                      onClick={() => FeedLikeChange(likeListFilterData, "Like")}
                    />
                    {
                      likeListFilterData?.filter(
                        (item) => item.Reaction === "Like"
                      ).length
                    }
                  </button>
                </div>
              )}

              {likeListFilterData?.filter((item) => item.Reaction === "Love")
                .length > 0 && (
                <div className="likediv">
                  <button className="" type="button">
                    <img
                      src="/images/main-body/post/emojis/1.gif"
                      onClick={() => FeedLikeChange(likeListFilterData, "Love")}
                    />
                    {
                      likeListFilterData?.filter(
                        (item) => item.Reaction === "Love"
                      ).length
                    }
                  </button>
                </div>
              )}

              {likeListFilterData?.filter((item) => item.Reaction === "Laugh")
                .length > 0 && (
                <div className="likediv">
                  <button className="" type="button">
                    <img
                      src="/images/main-body/post/emojis/2.gif"
                      onClick={() =>
                        FeedLikeChange(likeListFilterData, "Laugh")
                      }
                    />
                    {
                      likeListFilterData?.filter(
                        (item) => item.Reaction === "Laugh"
                      ).length
                    }
                  </button>
                </div>
              )}

              {likeListFilterData?.filter(
                (item) => item.Reaction === "Surprised"
              ).length > 0 && (
                <div className="likediv">
                  <button className="" type="button">
                    <img
                      src="/images/main-body/post/emojis/3.gif"
                      onClick={() =>
                        FeedLikeChange(likeListFilterData, "Surprised")
                      }
                    />
                    {
                      likeListFilterData?.filter(
                        (item) => item.Reaction === "Surprised"
                      ).length
                    }
                  </button>
                </div>
              )}

              {likeListFilterData?.filter((item) => item.Reaction === "Sad")
                .length > 0 && (
                <div className="likediv">
                  <button className="" type="button">
                    <img
                      src="/images/main-body/post/emojis/5.gif"
                      onClick={() => FeedLikeChange(likeListFilterData, "Sad")}
                    />
                    {
                      likeListFilterData?.filter(
                        (item) => item.Reaction === "Sad"
                      ).length
                    }
                  </button>
                </div>
              )}
            </div>
            <div className="friend-list p-2">
              {likeListData?.map((reaction) => (
                <div className="friend-item">
                  <div className="friend-info">
                    <img
                      src={reaction?.LikedByProfilePic || defaultImage}
                      onError={handleImageError}
                      alt="Profile"
                    />
                    <span>{reaction?.LikedBy}</span>{" "}
                    {MyEmojiReaction(reaction?.Reaction)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};
